<template>
    <div class="container">
        
    </div>
</template>

<script> 
import Auth from '@/utilities/auth'
import { UrlApi } from '@/api/url'

export default {
    components:{

    },
    data(){
        return{
            code:this.$route.params?.code || null,
        }
    },
    mounted(){
        if (!this.code) {
        this.$router.replace({ name: 'error-404' })
        return
        }

        const isCust = typeof Auth.isCustomerAuthenticated === 'function'
        ? Auth.isCustomerAuthenticated()
        : Auth.customerAuthenticated

        this.getRoute()
    },
    methods:{
        getRoute() {
      UrlApi.Redirect(this.code)
        .then(res => {
          const url = res?.data?.Data ?? res?.data
          if (typeof url === 'string' && url) {
            window.location.href = url
          } else {
            this.$router.replace({ name: 'error-404' })
          }
        })
        .catch(err => {
          this.$result?.(null, err)
          this.$router.replace({ name: 'error-404' })
        })
    },
  },
}
</script>
